/**
 * usePermitStatusList Hook
 *
 * React Query hook for fetching permit status options for the permit status dropdown.
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getPermitStatusList } from '../api/permitStatusApi';

/**
 * Fetch permit statuses for the permit status dropdown on the job detail page.
 */
export function usePermitStatusList() {
  const queryKey = queryKeys.jobs.permitStatuses();

  const query = useQuery({
    queryKey,
    queryFn: () => getPermitStatusList(),
    staleTime: 5 * 60 * 1000, // 5 minutes - statuses don't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    status: query.status,
  };
}
